import { render, staticRenderFns } from "./root.vue?vue&type=template&id=6f33840c&scoped=true&"
import script from "./root.vue?vue&type=script&lang=ts&"
export * from "./root.vue?vue&type=script&lang=ts&"
import style0 from "./root.vue?vue&type=style&index=0&id=6f33840c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f33840c",
  null
  
)

export default component.exports